const LeaveConfirmationHook = {
  mounted() {
    window.CONFIRM_LEAVE_EL = this.el;

    this.onConfirmCallback;
    this.unloadCallback = this.beforeUnload.bind(this);
    this.modal = document.querySelector(this.el.dataset.modalSelector);

    window.addEventListener('beforeunload', this.unloadCallback);
    this.el.addEventListener('show', ({ detail }) => {
      liveSocket.execJS(this.modal, this.modal.getAttribute('data-show'));
      this.onConfirmCallback = detail.onConfirm;
    });

    this.el.addEventListener('confirm', () => {
      window.CONFIRM_LEAVE_EL = null;
      this.onConfirmCallback();
    });
  },

  destroyed() {
    window.CONFIRM_LEAVE_EL = null;
    window.removeEventListener('beforeunload', this.unloadCallback);
  },

  beforeUnload(e) {
    e.preventDefault();
  },

  showConfirmation(e) {},
};

export default LeaveConfirmationHook;
